import React, { useCallback } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

// Now just a deactivation modal - no modal required for activation
export const PipelineDeploymentModal = ({
  error = null,
  pipeline = {},
  onPipelineUpdated = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const workspaceId = pipeline?.workspace?.id;
  const isActive = pipeline?.deployed;

  const onConfirm = useCallback(() => {
    onPipelineUpdated(pipeline, workspaceId, !isActive);
  }, [onPipelineUpdated, pipeline, workspaceId, isActive])

  return (
    <ConfirmationDialog
      title={isActive ? 'Undeploy pipeline' : 'Deploy pipeline'}
      confirmButtonText={isActive ? 'Undeploy' : 'Deploy'}
      confirmButtonType={isActive ? 'danger' : 'primary'}
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="deploy-pipeline-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal flex flex-col p-2 m-1">
        <Label>
          Are you sure you want to { isActive ? 'undeploy' : 'deploy'} this pipeline?
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while updating the pipeline. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default PipelineDeploymentModal;
